export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  TAB: 'Tab',
};

export const KEY_VALUES = {
  [KEYS.ENTER]: KEYS.ENTER,
  [KEYS.ESCAPE]: KEYS.ESCAPE,
  13: KEYS.ENTER,
  27: KEYS.ESCAPE,
} as const;
